// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__gsBX3","container":"SectionFaq_container__pbwTJ","faq__title":"SectionFaq_faq__title__E_Tnx","faq__list-container":"SectionFaq_faq__list-container__a3pSS"};